import './index.css';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppProviders } from './contexts';
import { BrowserRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';

const GA_TRACKING_ID = 'G-Q015QJE7C5';

const tagManagerArgs = {
   gtmId: 'GTM-TWTHC94H',
};

TagManager.initialize(tagManagerArgs);

ReactGA.initialize(GA_TRACKING_ID);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
   <AppProviders>
      <BrowserRouter>
         <App />
      </BrowserRouter>
   </AppProviders>
);

reportWebVitals();
